import React from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';
import { useNavigate } from 'react-router-dom';

export default function CoverageGapAlert({ regions }) {
  const navigate = useNavigate();
  const lowCoverage = regions?.filter(r => r?.coverage < 75)?.sort((a, b) => a?.coverage - b?.coverage);
  const declining = regions?.filter(r => r?.growth < 0)?.sort((a, b) => a?.growth - b?.growth);

  if (lowCoverage?.length === 0 && declining?.length === 0) return null;

  return (
    <div className="rounded-xl p-4" style={{ background: 'var(--color-card)', border: '1px solid var(--color-border)' }}>
      <div className="flex items-center gap-2 mb-3">
        <Icon name="AlertTriangle" size={16} color="#D4AF37" strokeWidth={2} />
        <h3 className="font-heading font-semibold text-foreground text-sm">Coverage &amp; Performance Alerts</h3>
        <span className="ml-auto text-xs font-medium px-2 py-0.5 rounded-full" style={{ background: 'rgba(212, 175, 55, 0.12)', color: '#D4AF37', border: '1px solid rgba(212, 175, 55, 0.25)' }}>
          {lowCoverage?.length + declining?.length} issues
        </span>
      </div>
      {lowCoverage?.length > 0 && (
        <div className="mb-3">
          <p className="font-caption text-xs font-medium text-muted-foreground uppercase tracking-wider mb-2">Low Coverage</p>
          <div className="flex flex-col gap-1.5">
            {lowCoverage?.slice(0, 3)?.map((r) => (
              <div key={r?.id} className="flex items-center justify-between rounded-lg px-3 py-2" style={{ background: 'rgba(212, 175, 55, 0.08)', border: '1px solid rgba(212, 175, 55, 0.15)' }}>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full flex-shrink-0" style={{ background: '#D4AF37' }} />
                  <span className="font-caption text-xs text-foreground">{r?.name}</span>
                </div>
                <span className="font-data text-xs font-bold" style={{ color: '#D4AF37' }}>{r?.coverage}%</span>
              </div>
            ))}
          </div>
        </div>
      )}
      {declining?.length > 0 && (
        <div className="mb-3">
          <p className="font-caption text-xs font-medium text-muted-foreground uppercase tracking-wider mb-2">Declining Growth</p>
          <div className="flex flex-col gap-1.5">
            {declining?.slice(0, 3)?.map((r) => (
              <div key={r?.id} className="flex items-center justify-between rounded-lg px-3 py-2" style={{ background: 'rgba(239, 68, 68, 0.08)', border: '1px solid rgba(239, 68, 68, 0.15)' }}>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full flex-shrink-0 bg-red-500" />
                  <span className="font-caption text-xs text-foreground">{r?.name}</span>
                </div>
                <span className="font-data text-xs font-bold text-red-400">{r?.growth}%</span>
              </div>
            ))}
          </div>
        </div>
      )}
      <Button
        variant="outline"
        size="sm"
        fullWidth
        iconName="BarChart2"
        iconPosition="left"
        iconSize={13}
        onClick={() => navigate('/performance-analytics')}
      >
        View Full Analysis
      </Button>
    </div>
  );
}